import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { setConsultSource } from "../lib/consultSource";

// Inline CTA "funnel" toward the Contact section. variant: "light" | "dark" | "banner"
export default function ConsultCTA({ variant = "light", heading, body, source = "Home page — CTA banner" }) {
  const track = () => setConsultSource(source);

  if (variant === "banner") {
    return (
      <div className="bg-gradient-to-r from-[#1a2c4e] to-[#11203c] border-y border-[#b8924a]/40">
        <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#d4b87a] mb-2">{heading || "Speak With Our Attorneys"}</div>
            <p className="font-serif text-2xl md:text-3xl text-white leading-tight">
              {body || "Schedule a confidential consultation today."}
            </p>
          </div>
          <Button asChild className="rounded-none h-12 px-8 bg-[#b8924a] hover:bg-[#a07f3e] text-white uppercase tracking-[0.2em] text-[11px] font-medium border border-[#b8924a] shrink-0">
            <a href="#contact" onClick={track}>
              <Calendar className="w-4 h-4 mr-2" /> Schedule a Consultation
            </a>
          </Button>
        </div>
      </div>
    );
  }

  const isDark = variant === "dark";
  return (
    <div className={`mt-14 flex flex-col sm:flex-row items-center justify-center gap-5 border-t border-b py-8 ${isDark ? "border-white/15" : "border-stone-200"}`}>
      <p className={`font-serif text-xl md:text-2xl text-center sm:text-left ${isDark ? "text-white" : "text-[#1a2c4e]"}`}>
        {body || "Ready to discuss your matter?"}
      </p>
      <Button asChild className={`rounded-none h-11 px-7 uppercase tracking-[0.2em] text-[11px] font-medium border ${isDark ? "bg-[#b8924a] hover:bg-[#a07f3e] text-white border-[#b8924a]" : "bg-[#1a2c4e] hover:bg-[#11203c] text-white border-[#1a2c4e]"}`}>
        <a href="#contact" onClick={track}>Schedule a Consultation <ArrowRight className="w-4 h-4 ml-2" /></a>
      </Button>
    </div>
  );
}
